// @mui
import { styled } from '@mui/material/styles';
import {
  Typography, CardProps, Stack,
} from '@mui/material';
import { FC } from 'react';
import Box from '@mui/material/Box';
import Icon from '@mdi/react';
import { mdiCloseCircleOutline } from '@mdi/js';
import { bgGradient } from '@mgm/common/utils';

const StyledRoot = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  overflow: 'hidden',
  position: 'relative',
  color: (theme.palette.primary as any).darker,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const StyledBg = styled('div')(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: -1,
  width: '100%',
  height: '100%',
  position: 'absolute',
  backgroundColor: theme.palette.common.white,
  '&:before': {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: -2,
    content: '""',
    opacity: 0.2,
    ...bgGradient({
      direction: '135deg',
      startColor: theme.palette.primary.light,
      endColor: theme.palette.primary.main,
    }),
  },
}));

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title?: string;
  description?: string;
  img?: React.ReactNode;
  action?: React.ReactNode;
  onClose: () => void
}

const PricingBanner: FC<Props> = ({
  title,
  description,
  action,
  img,
  onClose,

}) => (
  <StyledRoot>
    {img && img}
    <Stack
      flexGrow={1}
      justifyContent="center"
      alignItems={{ xs: 'center', md: 'flex-start' }}
      sx={{
        pl: 5,
        py: { xs: 5, md: 0, lg: 4 },
        pr: { xs: 5, md: 0 },
        textAlign: { xs: 'center', md: 'left' },
      }}
    >
      <Stack pb={3} width="100%" direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" sx={{ whiteSpace: 'pre-line' }}>
          {title}
        </Typography>
        <Box px={4} onClick={onClose} className="align-center cursor-pointer">
          <Icon path={mdiCloseCircleOutline} size={1} />
        </Box>
      </Stack>

      <Typography
        variant="body1"
        width={600}
        sx={{
          opacity: 0.8,
          mb: { xs: 3, xl: 5 },
        }}
      >
        {description}
      </Typography>

      {action && action}
    </Stack>

    <StyledBg />
  </StyledRoot>
);

export {
  PricingBanner,
};
